import React from 'react';

function Delete() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20">
			<path
				fill="#768D95"
				d="M11.417 2.917H8.583a.708.708 0 00-.708.708v.708H4.333a.708.708 0 100 1.417h.709v10.625a.708.708 0 00.708.708h8.5a.708.708 0 00.708-.708V5.75h.709a.708.708 0 000-1.417h-3.542v-.708a.708.708 0 00-.708-.708zm2.125 12.75H6.458V5.75h7.084v9.917z"></path>
			<path
				fill="#768D95"
				d="M8.583 7.167a.708.708 0 00-.708.708v5.667a.708.708 0 101.417 0V7.875a.708.708 0 00-.709-.708zM10.708 7.875v5.667a.708.708 0 101.417 0V7.875a.709.709 0 00-1.417 0z"></path>
		</svg>
	);
}

export default Delete;
